<h1 mat-dialog-title>DAS Feedback</h1>
<form mat-dialog-content #feedbackForm="ngForm">
  <mat-form-field>
    <input [(ngModel)]="summary" name="summary" matInput required placeholder="Summary" />
    <mat-error>Summary is required</mat-error>
  </mat-form-field>

  <mat-form-field>
    <textarea
      [(ngModel)]="description"
      name="description"
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      placeholder="Description"
    ></textarea>
  </mat-form-field>
</form>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="true">CANCEL</button>
  <button mat-raised-button color="primary" (click)="sendFeedback()" [disabled]="form.invalid">SEND FEEDBACK</button>
</div>
